import { SVGProps } from 'react';

const Ship = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 10.189V14m0-3.811a2 2 0 0 1 .812.172L21 14a11.6 11.6 0 0 1-1.62 6M12 10.189a2 2 0 0 0-.812.172L3 14a11.6 11.6 0 0 0 2.81 7.76M12 2v3m7 8V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6m-3 8c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
    />
  </svg>
);
export default Ship;
